import reducers from './reducers';

export {
    actions as exampleOperations,
    default as examplesSaga,
} from './operations';

export default reducers;
